import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { mergeMapTo } from 'rxjs/operators';
import { take } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs'
import{ GlobalConstants } from '../common/global-constants';
import { SharedService } from './shared.service';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

const apiUrl = GlobalConstants.apiURL

@Injectable({
  providedIn: 'root'
})
export class MessagingService {
    currentMessage = new BehaviorSubject(null);

    constructor(
      private angularFireMessaging: AngularFireMessaging,private http:HttpClient, private sharedapi:SharedService) {
      
    }

    /**
     * update token in firebase database
     * 
     * @param userId userId as a key 
     * @param token token as a value
     */
    updateToken(userId, token) {
        // we can change this function to request our backend service
      
    }

    /**
     * request permission for notification from firebase cloud messaging
     * 
     * @param userId userId
     */
    requestPermission() 
    {
        this.angularFireMessaging.requestToken.subscribe(
        (token) => {
          localStorage.setItem('push_token',token);
        },
        (err) => {
          console.error('Unable to get permission to notify.', err);
        }
      );
    }

    /**
     * hook method when new notification received in foreground
     */
    receiveMessage() {
       return this.angularFireMessaging.messages
    }
    
    getNotification()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-notifications',{headers:webheader})
    }

    sendMessage(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'send-whatapp-message',data,{headers:webheader})
    }
    sendMediaMessage(data)
    {
        var formData: any = new FormData();
        for (const key in data)
        {
            formData.append(key, data[key]);
        }

        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'send-whatapp-media-message',formData,{headers:webheader})
    }

    sendTemplateMessage(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'send-whatapp-template-message',data,{headers:webheader})
    }

    getMessageByLead(lead_id)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-whats-app-messages/'+lead_id,{headers:webheader})
    }

    removeWhatsappNotification(lead_id)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'remove-whatsapp-notification/'+lead_id,{headers:webheader})
    }

    fetchAllLeads()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-user-leads',{headers:webheader})
    }

    getMessageByMobile(mobile)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-whatsapp-messages/'+mobile,{headers:webheader})
    }

}
